export const BG = Styles.color.grey.five;
export const COLOR = Styles.color.tertiary;
export const FONT = Styles.fontFamily.body;
export const BTN_FONT = Styles.fontFamily.base;
export const BTN_FONT_WEIGHT = 400;
export const BTN_TEXT_DECORATION = 'underline';
